module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "novalidate": ""
    }
  }, [_c('h2', {
    staticClass: "block__title mb-0"
  }, [_vm._v("แนบสลิปการโอน")]), _vm._v(" "), _c('div', {
    staticClass: "small mb-15"
  }, [_vm._v("อนุญาตไฟล์นามสกุล .jpg, .png, .jpeg")]), _vm._v(" "), _c('div', {
    staticClass: "dropbox"
  }, [_c('input', {
    ref: "fileInput",
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "disabled": _vm.isSaving,
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.filesChange($event.target.files)
      }
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('div', {
    staticClass: "dropbox-upload"
  }, [_vm._v("\n        กดเพื่อเลือกไฟล์ หรือ"), _c('br'), _vm._v("ลากไฟล์มาวาง\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('div', {
    staticClass: "dropbox-upload"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.uploadedUrl) ? _c('div', {
    staticClass: "-success"
  }, [_c('img', {
    ref: "preview",
    staticClass: "img-responsive img-thumbnail",
    attrs: {
      "src": _vm.uploadedUrl
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isSuccess) ? _c('div', {
    staticClass: "_clearfix"
  }, [_c('button', {
    staticClass: "btn btn--purple btn--center mb-20",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reset()
      }
    }
  }, [_vm._v("อัพโหลดใหม่อีกครั้ง")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "-inner"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-326f4110", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-326f4110","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadPicker.vue
// module id = 731
// module chunks = 1